import { useState } from "react";
import CouponInput from "../components/CouponInput";
import ProductSelector from "../components/ProductSelector";
import AddressForm from "../components/AddressForm";
import CartReview from "../components/CartReview";
import ConfirmationPopup from "../components/ConfirmationPopup";

import "../styles/global.css";
import "../styles/layout.css";
import "../styles/forms.css";
import "../styles/buttons.css";
import "../styles/components.css";

function HRJacketsPage() {
  const [couponValid, setCouponValid] = useState(false);
  const [cartItem, setCartItem] = useState(null);
  const [checkoutStep, setCheckoutStep] = useState(false);
  const [orderComplete, setOrderComplete] = useState(false);
  const [apiError, setApiError] = useState("");
  const [couponCode, setCouponCode] = useState("");

  const [products, setProducts] = useState([]);

  const handleCouponValid = (data) => {
    setProducts(data.products || []);
    setCouponCode(data.couponCode);
    setCouponValid(true);
  };

  const handleUpdateItem = (updatedItem) => {
    setCartItem(updatedItem);
  };

  return (
    <div className="usap-page">
      <div className="usap-page-header">
        <img
          className="usap-page-logo"
          src="/logos/usap_logo.png"
          alt="USAP logo"
        />
      </div>

      {!couponValid && (
        <CouponInput onValid={handleCouponValid} />
      )}

      {couponValid && !cartItem && (
        <ProductSelector
          products={products}
          onSelect={(item) => setCartItem(item)}
        />
      )}

      {couponValid && cartItem && !checkoutStep && (
        <CartReview
          item={cartItem}
          onBack={() => setCartItem(null)}
          onUpdateItem={handleUpdateItem}
          onCheckout={(updatedItem) => {
            setCartItem(updatedItem);
            setCheckoutStep(true);
          }}
        />
      )}

      {couponValid && checkoutStep && !orderComplete && (
        <AddressForm
          sku={cartItem?.sku}
          optionId={cartItem?.optionId}
          optionValue={cartItem?.optionValue}
          sizeOptionId={cartItem?.sizeOptionId}
          sizeValue={cartItem?.selectedSize}
          couponCode={couponCode}
          onBack={() => setCheckoutStep(false)}
          onSuccess={() => setOrderComplete(true)}
          onError={(msg) => setApiError(msg)}
        />
      )}

      {orderComplete && <ConfirmationPopup />}

      {apiError && (
        <ConfirmationPopup message={apiError} isError />
      )}
    </div>
  );
}

export default HRJacketsPage;
